import Loadable from 'react-loadable';

import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () =>
    import(
      '../CostcowaterCookies' /* webpackChunkName: "CostcowaterCookies" */
    ),
  loading: LoadingIndicator,
});
